(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@calendair/core"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@calendair/core", "vue"], factory);
	else if(typeof exports === 'object')
		exports["booking"] = factory(require("@calendair/core"), require("vue"));
	else
		root["booking"] = factory(root["@calendair/core"], root["vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7539__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 